import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportSalesByCst } from './SalesByCst.service';
import reportNotificationError from '@/utils/functions/notificationErrorNetReport';

export function useSalesByCstReport() {
  return useMutation(getQuestReportSalesByCst, {
    onSuccess() {
      notification.success({
        message: 'O relatório Vendas por CST foi gerado com sucesso!',
      });
    },

    onError(error) {
      reportNotificationError(error);
    },
  });
}
